import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";
import PinIcon from '@assets/svg/pin.svg';


export const ImageRow = styled.div`
    width:100%;
    display:flex;
    align-items: center;
`;

export const ImageWrapper = styled.div`
    width:20%;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.2);
    position: relative;
    
    img{
        width:100%;
        height:100%;
        object-fit: cover;
    }
`;

export const NameCol = styled.div`
    display:flex;
    flex-direction: column;
    padding-left: 14px;
    width:80%;

    span{
        font-size: 18px;
        line-height: 22px;
    }
    span:nth-of-type(1){
        font-size: 20px;
        font-weight: 500;
    }
`;

export const Action = styled.div`
    position: absolute;
    top:20px;
    right:18px;
    cursor: pointer;

    > svg{
        height:26px;

        path{
            fill:#494949;
        }
    }
`;


export const Drop = styled.div<{show:boolean}>`
    display: ${props => props.show?"block":"none"};
    background:#fff;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.25);
    position: absolute;
    top:30px;
    right:0;
    padding:6px;
    border-radius: 3px;
`;

export const RItem = styled.div`
  display:flex;  
  align-items: center;
  gap:8px;
  padding:4px 8px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  position: relative;

  > div{
    display:flex;  
    align-items: center;
    gap:8px;
  }

  

  svg{
        height:22px;
        width:22px;

        path{
            /* fill:#494949; */
        }
        rect{
            /* fill:#494949; */
        }
    }

    :hover{
        background:#eeeded;
    }
`;

export const Pin_Icon = styled(PinIcon)`
    
    path{
        fill:#494949;
    }
    rect{
        fill:#494949;
    }

    :hover{
        background:#eeeded;
    }
`


export const TextRow = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width:100%;
    padding:14% 0 8% 0;

    
    span{
        font-size: 20px;
        font-weight: 500;
        color:#303030;
    }

    p{
        font-size: 62px;
        line-height: 64px;
        font-weight: 600;
    }
`;

export const GraphRow = styled.div`
    width:100%;
    height:50%;
    margin-top: auto;
    position: relative;
`;